<template>
  <li class="has-sub">
    <a href="javascript:;">
      <b class="caret pull-right"></b>
      <i class="fa fa-money"></i>
      <span>Pembayaran</span>
    </a>
    <ul class="sub-menu">
      <li><router-link to="/pembayaran">Pembayaran User</router-link></li>
      <li><router-link to="/produk">Produk</router-link></li>
      <li><router-link to="/metode-pembayaran">Metode Pembayaran</router-link></li>
      <li><router-link to="/ticket-usage">Ticket Usage</router-link></li>
      <li><router-link to="/katalog-tiket">Katalog Tiket</router-link></li>
    </ul>
  </li>
</template>
<script>
export default {
  name: 'pembayaran-nav'
}
</script>




// WEBPACK FOOTER //
// Navigation.vue?58db30ca